import { isValidDateString } from '@/common/utils/dateValidator'
import { z } from 'zod'

export const anticipateGovernmentAllocationSchema = z.object({
  requested_new_start_date: z
    .string({ message: 'Campo obrigatório' })
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, { message: 'Use o formato DD/MM/AAAA' })
    .refine(isValidDateString, { message: 'Data inválida' }),
})

export type AnticipateGovernmentAllocationSchema = z.infer<typeof anticipateGovernmentAllocationSchema>
